module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-body__wrap"
  }, [(_vm.placeholder_list == 1) ? _c('div', {
    staticClass: "cb-placeholder__wrap"
  }, [_c('cb-placeholder', {
    attrs: {
      "custom-class": 'md rect-sm'
    }
  }), _vm._v(" "), _c('cb-placeholder', {
    attrs: {
      "custom-class": 'st rect-lg'
    }
  }), _vm._v(" "), _c('cb-placeholder', {
    attrs: {
      "custom-class": 'sm'
    }
  }), _vm._v(" "), _c('cb-placeholder', {
    attrs: {
      "custom-class": 'sm'
    }
  })], 1) : _vm._l((_vm.placeholder_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cb-placeholder__wrap"
    }, [_c('div', {
      staticClass: "cb-placeholder__container"
    }, [_c('cb-placeholder', {
      staticClass: "cb-placeholder__left",
      attrs: {
        "custom-class": 'sm rect-xl'
      }
    }), _vm._v(" "), _c('cb-placeholder', {
      staticClass: "cb-placeholder__right",
      attrs: {
        "custom-class": 'sm rect-sm'
      }
    })], 1), _vm._v(" "), _c('cb-placeholder', {
      attrs: {
        "custom-class": 'md rect-sm'
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45b836d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/CartScreen.vue
// module id = 598
// module chunks = 66